"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
// Generated from ../../../cs/src/Contracts/TunnelServiceProperties.cs
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TunnelServiceProperties = exports.nonProdGitHubAppClientId = exports.prodGitHubAppClientId = exports.devThirdPartyAppId = exports.ppeThirdPartyAppId = exports.prodThirdPartyAppId = exports.nonProdFirstPartyAppId = exports.prodFirstPartyAppId = exports.devDnsName = exports.ppeDnsName = exports.prodDnsName = void 0;
/**
 * Global DNS name of the production tunnel service.
 */
exports.prodDnsName = 'global.rel.tunnels.api.visualstudio.com';
/**
 * Global DNS name of the pre-production tunnel service.
 */
exports.ppeDnsName = 'global.rel.tunnels.ppe.api.visualstudio.com';
/**
 * Global DNS name of the development tunnel service.
 */
exports.devDnsName = 'global.ci.tunnels.dev.api.visualstudio.com';
/**
 * First-party app ID: `Visual Studio Tunnel Service`
 *
 * Used for authenticating AAD/MSA users, and service principals outside the AME tenant,
 * in the PROD service environment.
 */
exports.prodFirstPartyAppId = '46da2f7e-b5ef-422a-88d4-2a7f9de6a0b2';
/**
 * First-party app ID: `Visual Studio Tunnel Service - Test`
 *
 * Used for authenticating AAD/MSA users, and service principals outside the AME tenant,
 * in the PPE and DEV service environments.
 */
exports.nonProdFirstPartyAppId = '54c45752-bacd-424a-b928-652f3eca2b18';
/**
 * Third-party app ID: `tunnels-prod-app-sp`
 *
 * Used for authenticating internal AAD service principals in the AME tenant, in the PROD
 * service environment.
 */
exports.prodThirdPartyAppId = 'ce65d243-a913-4cae-a7dd-cb52e9f77647';
/**
 * Third-party app ID: `tunnels-ppe-app-sp`
 *
 * Used for authenticating internal AAD service principals in the AME tenant, in the PPE
 * service environment.
 */
exports.ppeThirdPartyAppId = '544167a6-f431-4518-aac6-2fd50071928e';
/**
 * Third-party app ID: `tunnels-dev-app-sp`
 *
 * Used for authenticating internal AAD service principals in the corp tenant (not AME!),
 * in the DEV service environment.
 */
exports.devThirdPartyAppId = 'a118c979-0249-44bb-8f95-eb0457127aeb';
/**
 * GitHub App Client ID for 'Visual Studio Tunnel Service'
 *
 * Used by client apps that authenticate tunnel users with GitHub, in the PROD service
 * environment.
 */
exports.prodGitHubAppClientId = 'Iv1.e7b89e013f801f03';
/**
 * GitHub App Client ID for 'Visual Studio Tunnel Service - Test'
 *
 * Used by client apps that authenticate tunnel users with GitHub, in the PPE and DEV
 * service environments.
 */
exports.nonProdGitHubAppClientId = 'Iv1.b231c327f1eaa229';
// Import static members from a non-generated file,
// and re-export them as an object with the same name as the interface.
const tunnelServicePropertiesStatics_1 = require("./tunnelServicePropertiesStatics");
exports.TunnelServiceProperties = {
    production: tunnelServicePropertiesStatics_1.production,
    staging: tunnelServicePropertiesStatics_1.staging,
    development: tunnelServicePropertiesStatics_1.development,
    environment: tunnelServicePropertiesStatics_1.environment,
};
//# sourceMappingURL=tunnelServiceProperties.js.map